import { render, staticRenderFns } from "./LoginSignup.vue?vue&type=template&id=0727d278&scoped=true&"
import script from "./LoginSignup.vue?vue&type=script&lang=js&"
export * from "./LoginSignup.vue?vue&type=script&lang=js&"
import style0 from "./LoginSignup.vue?vue&type=style&index=0&id=0727d278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727d278",
  null
  
)

export default component.exports